export const routePaths = {
  lead: '/lead',
  leadForm: '/lead/form',
}
